
/**
 * Init_nbResult_top.js
 */


function init() {

    var isStorage = !!sessionStorage;

    if(isStorage) {

		var isStr = StorageOperator.isNotStorageData('session', 'state' );
		if(isStr) {
			 initSecond();
		 }else {
 
			 var isStrLo = StorageOperator.isNotStorageData('local', 'state');
			 var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
			 var boo = setOr34State(or34);
 
			 initSecond();
		 };

    }else {
        alert('お使いのブラウザでは本アプリケーションは正常に動作しません');
    };

};



function setOr34State(val) {

	var stateObj = StorageOperator.makePageStateJson( val );

	var boo = [false, false];
	try {
		boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
	}catch(exeption) {
		//alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};
	return boo[0];
};



function initSecond() {
	General_init.init();
	initTherd();
};


function initTherd() {

	var resultDataArr = allDataObj.result;
	makeTable(resultDataArr);
};


function makeTable(resultDataArr) {

	var table = document.getElementById('now-result');

	var size = resultDataArr.length;
	var arr = resultDataArr;

	for(var i=size-1, n=size-50; i>=n; i--) {

		var trTime = document.createElement('tr');
		var tdTime = document.createElement('td');
		tdTime.className = 'times';
		tdTime.colSpan = 2;
		tdTime.textContent = '第 '+Number(arr[i].nu)+' 回';
		trTime.appendChild(tdTime);
		trTime.id = 'index-'+arr[i].nu;
		
		var trDate = document.createElement('tr');
		var tdDateLa = document.createElement('td');
		tdDateLa.textContent = '抽せん日';
		var tdDateVa = document.createElement('td');
		tdDateVa.textContent = arr[i].ye+'/'+arr[i].mo+'/'+arr[i].da;
		trDate.appendChild(tdDateLa);
		trDate.appendChild(tdDateVa);

		var trNb3 = document.createElement('tr');
		var tdNb3La = document.createElement('td');
		tdNb3La.textContent = 'ナンバーズ３';
		var tdNb3Va = document.createElement('td');
		//
		var nb3Sort = stringNumberArraySort( arr[i].nb3 );
		var a3Va = document.createElement('a');

		a3Va.href = "../numb-box/nb3/nb3-box-"+nb3Sort+".html";
		a3Va.textContent = arr[i].nb3;
		tdNb3Va.appendChild(a3Va);
		//
		trNb3.appendChild(tdNb3La);
		trNb3.appendChild(tdNb3Va);

		var trNb4 = document.createElement('tr');
		var tdNb4La = document.createElement('td');
		tdNb4La.textContent = 'ナンバーズ４';
		var tdNb4Va = document.createElement('td');
		//
		var nb4Sort = stringNumberArraySort( arr[i].nb4 );
		var a4Va = document.createElement('a');
		a4Va.href = "../numb-box/nb4/nb4-box-"+nb4Sort+".html";
		a4Va.textContent = arr[i].nb4;
		tdNb4Va.appendChild(a4Va);
		//
		trNb4.appendChild(tdNb4La);
		trNb4.appendChild(tdNb4Va);

		table.appendChild(trTime);
		table.appendChild(trDate);
		table.appendChild(trNb3);
		table.appendChild(trNb4);

		if(i !== n) {
			var trSp = document.createElement('tr');
			var tdSp = document.createElement('td');
			tdSp.className = 'sapse';
			tdSp.colSpan = 2;
			trSp.appendChild(tdSp);
			table.appendChild( trSp );
		};

	};
};
function stringNumberArraySort( strNumb ) {

	var arr = [];
	for(var i=0, n=strNumb.length; i<n; i++) {
		arr.push(Number(strNumb.charAt(i)));
	};
	arr.sort();
	var text = "";
	for(var i=0, n=arr.length; i<n; i++) {
		text += arr[i];
	};
	return text;
};



function numberSearch() {

	var lastNum = pastTableLatest();


    var field = document.getElementById('numb-text');
    var val = field.value;

    if(val.length>0) {
        var arr = [];
        for(var i=0, n=val.length; i<n; i++) {
            arr.push( Number(val.charAt(i)) );
        };
        var boo = true;
        for(var i=0, n=arr.length; i<n; i++) {
            if( Number.isNaN( arr[i] ) ) {  boo = false;  };
		};
			
        if(boo) {

			var intVal = Number(val);

			var size = resultDataArr.length;
			var neirLast = size-50;

			if(intVal <= neirLast) {

				if(intVal<=lastNum && intVal>0) {

					var urlNum = lastNum-49;
					for(var i=1, n=lastNum; i<n; i+=50) {
						if(i>intVal) {
							urlNum = i-50;
							break;
						};
					};

					var urlNumStr = ''+urlNum;

					arr = [];
        			for(var i=0, n=urlNumStr.length; i<n; i++) {
            			arr.push( Number(urlNumStr.charAt(i)) );
        			};

					var text = arrayFormat(arr);

					var url = 'nb-rt-past/nb-rt-'+text+'.html'+'#index-'+intVal;

					location.href = url;

				}else {
					field.value = '';
				};
			}else {

				var size = resultDataArr.length;

				if(intVal > 0 && intVal <= size) {
					var size = resultDataArr.length;
					var neirLast = size-50;
					if(intVal > neirLast) {

						General_init.skipeBottom( 'index-'+intVal );
						
						//var url = '#index-'+intVal;
						//location.href = url;
						
					};
				}else {
					field.value = '';
				};				
			};
        }else {
             field.value = '';
        };
    }else {
        field.value = '';
	};
};




function arrayFormat(arr) {

		var text = '';
		var size = arr.length;
		var zz = 4-size;
        for(var i=0; i<4; i++) {
            text += i<zz ? '0' : arr[i-zz];
        };
        return text;
};
	



function pastTableLatest() {

		var trs = document.querySelectorAll('#index tr');
	
		var trFt = trs[1];
		var tds = trFt.childNodes;
		var tdsZ = nodeFormatArray( tds );

		var td = tdsZ[tdsZ.length-1];

		var hrefUrl = '';

		if(nodeFormatArray( td.childNodes ).length > 0) {
			var tda = nodeFormatArray( td.childNodes )[0];
			if(tda.href!=='') {
				hrefUrl = tda.href;
			}else {
				td = tdsZ[0];
				hrefUrl = nodeFormatArray( td.childNodes )[0].href;
			};
		}else {
			td = tdsZ[0];
			hrefUrl = nodeFormatArray( td.childNodes )[0].href;
		};

		var urlNum = hrefUrl.match(/[0-9]{4}/);
		var lastNum = Number(urlNum[0])+49;

		return lastNum;
};
function nodeFormatArray(nodeArr, type=1) {

	var rt = [];
	for(var i=0, n=nodeArr.length; i<n; i++) {
		if(nodeArr[i].nodeType===type) {   rt.push(nodeArr[i]);   };
	};
	return rt;
};
